import { createAccordionIdProps } from '../types';

export function createAccordionId({ id, eventKey, suffix }: createAccordionIdProps): string {
	if (id) {
		return id + '_' + suffix + '_' + eventKey;
	}

	return '';
}
